var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Upload',{attrs:{"value":_vm.value,"show-upload-list":false,"before-upload":_vm.beforeUpload,"format":_vm.extensions,"action":''}}),_c('UploadList',{attrs:{"files":_vm.value},on:{"on-file-remove":_vm.removeFile}}),(_vm.uploadInProcess)?_c('Spin',{attrs:{"size":"large","fix":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }